<template>
  <div
    v-clickoutside="close"
    class="scope-options top-fade-in"
    :style="`top: ${top}px; left: ${left}px;`"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.scope-options {
  position: absolute;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: white;
  z-index: 11;
  box-shadow: 0px 2px 40px rgb(5 45 97 / 70%);
}
</style>
